_ = require 'underscore'
CardLocationButtonView = require 'app/scripts/views/map/card-location-button-view'
Controller = require 'app/scripts/controller'
CustomFieldCardButtonView = require 'app/scripts/views/custom-field/custom-field-card-button-view'
PluginButtonsView = require 'app/scripts/views/plugin/plugin-buttons-view'
PluginCardButtonView = require 'app/scripts/views/plugin/plugin-card-button-view'
sidebarAction = require 'app/scripts/views/templates/card_detail_sidebar_button'
t = require('app/scripts/views/internal/teacup-with-helpers')('card_detail')
{ trackUe } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'

CUSTOM_FIELDS_ID = require('@trello/config').customFieldsId

_placeholderCountCache = {}

nativeCustomFieldsEnabled = (board) ->
  board.isPluginEnabled(CUSTOM_FIELDS_ID) &&
  board.editable()

template = t.renderable ({ showGetPups, hasButtons, placeholders }) ->
  t.h3 'mod-no-top-margin', ->
    t.format 'plugins'
  t.div '.u-clearfix.js-button-list', ->
    if placeholders
      _.times placeholders, ->
        t.a ".button-link.disabled", ->
          t.span ''

  if showGetPups
    t.div ->
      t.a '.quiet-button.js-get-pups.get-pups', { href: '#' }, ->
        if hasButtons || placeholders
          t.format 'get-more-pups'
        else
          t.format 'get-pups'

module.exports = class PluginCardButtonsView extends PluginButtonsView
  tagName: 'div'
  className: 'window-module u-clearfix hide'
  buttonsSelector: '.js-button-list'
  buttonView: PluginCardButtonView
  events:
    'click .js-get-pups': 'showPowerUps'

  _getPlaceholderCountCacheKey: ->
    "#{@model.getBoard().id}:#{@model.getBoard().idPluginsEnabled().sort().join(':')}"

  getPlaceholderCount: ->
    placeholders = 0
    if !@model.getBoard().editable()
      return placeholders

    placeholderCountCacheKey = @_getPlaceholderCountCacheKey()
    if _placeholderCountCache[placeholderCountCacheKey]
      placeholders = _placeholderCountCache[placeholderCountCacheKey]
    else
      # we are going to make a guesstimate on how many buttons we can expect
      # our assumption is that a plugin that declares it supports the 'card-buttons'
      # capability is most likely to give us back exactly one button
      # NOTE: plugins are loading asynchronously from the board and speed here matters
      # that means if a person loads a card directly, its possible the actual plugins
      # haven't loaded yet, so we won't wait on them, we'll skip them
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      ModelCache = require 'app/scripts/db/model-cache'
      placeholders = @model.getBoard().idPluginsEnabled()
        .map((idPlugin) -> ModelCache.get('Plugin', idPlugin))
        .filter((plugin) -> plugin? && _.contains(plugin.get('capabilities'), 'card-buttons'))
        .length

    return placeholders

  hideContainer: ->
    !@model.getBoard().editable()

  renderContainer: (pluginButtons, loading = false) ->
    hasButtons = pluginButtons.length > 0
    showGetPups = @model.getBoard().editable()
    placeholders = if !loading then 0 else @getPlaceholderCount()

    if loading
      @placeholderCount = placeholders

    @$el.html(template({ hasButtons, showGetPups, placeholders }))
    @$('.js-button-list')

  renderButtons: (pluginButtons) ->
    board = @model.getBoard()

    if nativeCustomFieldsEnabled(board)
      pluginButtons.push
        text: t.l('custom-fields')
        view: CustomFieldCardButtonView

    if board.isMapPowerUpEnabled() && board.editable()
      pluginButtons.push
        text: t.l('location')
        view: CardLocationButtonView

    super(pluginButtons)

    actualCount = @$('.js-button-list').children().length
    _placeholderCountCache[@_getPlaceholderCountCacheKey()] = actualCount

  runnerOptions: ->
    command: 'card-buttons'
    board: @model.getBoard()
    card: @model

  renderOnce: ->
    @renderContainer([], true)
    @$el.toggleClass('hide', @hideContainer())
    super

  showPowerUps: (e) ->
    Util.stop(e)

    boardView = Controller.getCurrentBoardView()
    boardView.navigateToDirectory(@model)
    trackUe('board view', 'opens', 'Power-Up directory home page', '', '', 'by clicking Power-Ups link on card-back')
